import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './styles/tailwind.css';
import '@qtm/tokens/dist/tokens-dark.css';
import { Provider } from 'react-redux';  
import store from './state/store'; 
import'./index.css';




const handleDarkMode = (e) => {
  if (e.matches) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};


const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
handleDarkMode(mediaQuery); 
mediaQuery.addEventListener('change', handleDarkMode); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <Provider store={store}>
   
      <App />
    
  </Provider>
  ,
  
);

reportWebVitals();
